import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import CommonApis from "../../utils/commonApis";
import * as hometrainingActions from "store/modules/hometraining";
import { withRouter } from "react-router-dom";
import HomeHeader from "../../components/HomeTraning/HomeHeader/HomeHeader";
import QuetureList from "../../components/QuetureList/QuetureList";
import "./_review.scss";
import Filter from "../../components/Filter/Filter";
import { Skeleton, Button } from "antd";
import QuizList from "../../components/QuizList/QuizList";
import ReviewQuetureList from "../../components/QuetureList/ReviewQuetureList";
import { filter, values, mapValues, uniq, includes } from "lodash";
import PopupQueture from "../../components/PopupQueture/PopupQueture";
import { getKoreanDate } from "../../utils/utils";
import HometrainingApis from "utils/hometrainingApis";
import { getSeqText } from "utils/utils";
import axios from "axios";
import QuebonSongRow from "./components/QuebonSongRow/QuebonSongRow";
import QbPlayer from "components/QbPlayer/QbPlayer";
import Popup from "components/Popup/Popup";

// 페이지당 항목 수 상수
const PAGE_COUNT = 10;

/**
 * 깨처 다시보기 페이지 컴포넌트
 * 수강한 강의의 깨처 콘텐츠를 다시 볼 수 있는 기능을 제공
 */
class Review extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // 퀴즈 관련 상태
      solveQuiz: false,
      quizList: [],
      quizTitle: null,
      quizQuetureId: null,
      quizLectureId: null,
      isSolveEndQuiz: false,

      // 팝업 관련 상태
      popupQuetureData: null,
      popupQuebonSongData: null,

      // 정렬 및 필터링 상태
      sortType: "newest",
      sortReverse: false,
      
      // 데이터 리스트 상태
      lectureList: [], // 전체 강의 목록
      displayList: [], // 현재 표시되는 강의 목록 (필터링 + 검색 적용)
      
      // 필터 옵션
      dateList: [],
      courseTitle: [],
      lectureCountFilter: [],
      
      // 현재 적용된 필터 값들
      searchTitle: "",
      filterValue: null, // 회차 필터 값
      onFilterTitle: null, // 코스 필터 값
      
      // 페이지네이션
      currentPage: 1,
      totalPages: 1,
    };
  }

  componentDidMount() {
    const { user } = this.props;
    
    // 현재 진행 중인 수업이 있는지 확인
    HometrainingApis.currentLecture(user)
      .then((isStart) => {
        if (isStart) {
          // 진행 중인 수업이 있으면 교실로 이동
          this.props.history.push(`/classroom/${user.classroom.classroomId}`);
        } else {
          // 없으면 강의 목록 로드
          this.props.HometrainingActions.getLectures();
        }
      })
      .catch((e) => {
        console.error("현재 강의 확인 중 오류:", e);
        this.props.HometrainingActions.getLectures();
      });
  }

  componentDidUpdate(prevProps) {
    // 강의 목록이 업데이트되면 초기 데이터 처리
    if (prevProps.lectures !== this.props.lectures) {
      this.initializeLectureData();
    }
  }

  /**
   * 강의 데이터 초기화 및 필터 옵션 생성
   */
  initializeLectureData = () => {
    const { lectures, user } = this.props;

    // 날짜 목록 생성 (YYYY-MM 형식)
    const dateList = uniq(
      values(mapValues(lectures, (o) => o.date.slice(0, 7)))
    );

    // 사용자가 수강한 강의 ID 목록
    const userLectureIds = values(
      mapValues(user.lectures, (o) => o.lectureId)
    );

    // 코스 타이틀 목록 생성
    const courseTitles = uniq(
      values(mapValues(lectures, (o) => o.courseTitle[0]))
    ).sort();

    // 회차별 필터 옵션 생성
    const lectureCountFilter = uniq(
      values(
        mapValues(lectures, (o) => {
          const lessonNumber = parseInt(o.title.replace(/[^0-9]/g, ""));
          
          if (lessonNumber >= 1 && lessonNumber <= 10) return "1회차~10회차";
          if (lessonNumber >= 11 && lessonNumber <= 20) return "11회차~20회차";
          if (lessonNumber >= 21 && lessonNumber <= 30) return "21회차~30회차";
          if (lessonNumber >= 31 && lessonNumber <= 40) return "31회차~40회차";
          if (lessonNumber >= 41 && lessonNumber <= 50) return "41회차~50회차";
          if (lessonNumber >= 51 && lessonNumber <= 60) return "51회차~60회차";
          
          return null;
        })
      ).filter(Boolean)
    );

    // 사용자가 수강한 강의만 필터링
    const userLectures = filter(lectures, (lecture) =>
      includes(userLectureIds, lecture.lectureId)
    );

    this.setState({
      lectureList: userLectures,
      displayList: userLectures,
      dateList,
      courseTitle: courseTitles,
      lectureCountFilter,
      searchTitle: "",
      currentPage: 1,
      totalPages: Math.ceil(userLectures.length / PAGE_COUNT),
    });
  };

  /**
   * 퀴즈 풀이 시작 (강의 중 퀴즈)
   */
  handleEnterSolveQuiz = (quetureData, lectureId) => {
    const { lectures } = this.props;
    const lecture = lectures.find((l) => l.lectureId === lectureId);

    if (lecture) {
      const quizSection = lecture.sections.find(
        (s) => s.type === "QUIZ" && s.quetureId === quetureData.quetureId
      );

      if (quizSection) {
        this.setState({
          solveQuiz: true,
          quizList: quizSection.quiz,
          quizTitle: quetureData.title,
          quizQuetureId: quetureData.quetureId,
          quizLectureId: lectureId,
          isSolveEndQuiz: false,
        });
      }
    }
  };

  /**
   * 마무리 퀴즈 풀이 시작
   */
  handleEnterEndQuiz = (quetureData, lectureId) => {
    const { lectures } = this.props;
    const lecture = lectures.find((l) => l.lectureId === lectureId);

    if (lecture) {
      const quizSection = lecture.sections.find((s) => s.type === "ENDQUIZ");

      if (quizSection) {
        this.setState({
          solveQuiz: true,
          quizList: quizSection.quiz,
          quizTitle: quetureData.title,
          quizQuetureId: quetureData.quetureId,
          quizLectureId: lectureId,
          isSolveEndQuiz: true,
        });
      }
    }
  };

  /**
   * 해당 강의에 퀴즈가 있는지 확인
   */
  handleFindSolveQuiz = (quetureData, lectureId) => {
    const { lectures } = this.props;
    const lecture = lectures.find((l) => l.lectureId === lectureId);

    if (lecture) {
      const quizSection = lecture.sections.find(
        (s) => s.type === "QUIZ" && s.quetureId === quetureData.quetureId
      );
      return !!quizSection;
    }
    return false;
  };

  /**
   * 해당 강의에 마무리 퀴즈가 있는지 확인
   */
  handleFindEndQuiz = (quetureData, lectureId) => {
    const { lectures } = this.props;
    const lecture = lectures.find((l) => l.lectureId === lectureId);

    if (lecture) {
      const quizSection = lecture.sections.find((s) => s.type === "ENDQUIZ");
      return !!quizSection;
    }
    return false;
  };

  /**
   * 정렬 방식 변경 처리
   */
  handleChangeSortType = (value) => {
    if (value !== this.state.sortType) {
      const newSortReverse = !this.state.sortReverse;
      
      this.setState({
        sortType: value,
        sortReverse: newSortReverse,
        currentPage: 1,
      }, () => {
        this.applyFiltersAndSearch();
      });
    }
  };

  /**
   * 검색어로 깨처 제목/개념 태그 검색
   */
  searchByTitle = async (searchValue, lectureList) => {
    if (!searchValue.trim()) {
      return lectureList;
    }

    try {
      // 모든 강의의 깨처 ID 수집
      const quetureIds = [];
      lectureList.forEach((lecture) => {
        lecture.sections
          .filter((section) => section.type === "QUETURE")
          .forEach((section) => {
            quetureIds.push(section.quetureId);
          });
      });

      if (quetureIds.length === 0) {
        return [];
      }

      // 깨처 데이터 가져오기
      const responses = await CommonApis.getQuetureDataList(quetureIds);
      const matchingQuetureIds = [];

      // 검색어와 매칭되는 깨처 찾기
      await axios.all(responses).then(
        axios.spread((...responses) => {
          responses.forEach((response) => {
            if (response.data) {
              const title = response.data.title.replace(/ /g, "");
              const searchTag = searchValue.replace(/ /g, "");
              const conceptTags = response.data.conceptTags.join(",");

              if (title.includes(searchTag) || conceptTags.includes(searchTag)) {
                matchingQuetureIds.push(response.data.quetureId);
              }
            }
          });
        })
      );

      // 매칭되는 깨처가 포함된 강의만 필터링
      return lectureList.filter((lecture) => {
        return lecture.sections.some((section) =>
          matchingQuetureIds.includes(section.quetureId)
        );
      });
    } catch (error) {
      console.error("검색 중 오류:", error);
      return lectureList;
    }
  };

  /**
   * 회차별 필터링
   */
  applyLessonFilter = (lectureList, filterValue) => {
    if (!filterValue) return lectureList;

    return filter(lectureList, (lecture) => {
      const lessonNumber = parseInt(lecture.title.replace(/[^0-9]/g, ""));
      const startNumber = parseInt(filterValue[0].replace(/[^0-9]/g, ""));
      const endNumber = parseInt(filterValue[2].replace(/[^0-9]/g, ""));

      return lessonNumber >= startNumber && lessonNumber <= endNumber;
    });
  };

  /**
   * 코스별 필터링
   */
  applyCourseFilter = (lectureList, courseTitle) => {
    if (!courseTitle) return lectureList;

    return filter(lectureList, (lecture) =>
      lecture.courseTitle.includes(courseTitle)
    );
  };

  /**
   * 모든 필터와 검색 조건을 적용하여 표시할 강의 목록 업데이트
   */
  applyFiltersAndSearch = async () => {
    const { lectureList, searchTitle, filterValue, onFilterTitle, sortReverse } = this.state;
    
    let filteredList = [...lectureList];

    // 1. 코스 필터 적용
    filteredList = this.applyCourseFilter(filteredList, onFilterTitle);

    // 2. 회차 필터 적용
    filteredList = this.applyLessonFilter(filteredList, filterValue);

    // 3. 검색 적용
    if (searchTitle.trim()) {
      filteredList = await this.searchByTitle(searchTitle, filteredList);
    }

    // 4. 정렬 적용
    if (sortReverse) {
      filteredList = filteredList.reverse();
    }

    this.setState({
      displayList: filteredList,
      totalPages: Math.ceil(filteredList.length / PAGE_COUNT),
      currentPage: 1,
    });
  };

  /**
   * 검색어 입력 처리
   */
  handleSearchTitle = (value) => {
    this.setState({
      searchTitle: value,
      currentPage: 1,
    }, () => {
      this.applyFiltersAndSearch();
    });
  };

  /**
   * 회차 필터 변경 처리
   */
  handleFilter = (value) => {
    this.setState({
      filterValue: value,
      currentPage: 1,
    }, () => {
      this.applyFiltersAndSearch();
    });
  };

  /**
   * 코스 필터 변경 처리
   */
  handleFilterCourseTitle = (value) => {
    this.setState({
      onFilterTitle: value,
      currentPage: 1,
    }, () => {
      this.applyFiltersAndSearch();
    });
  };

  /**
   * 페이지 변경 처리
   */
  handlePageChange = (page) => {
    this.setState({
      currentPage: page,
    });
  };

  /**
   * 현재 페이지에 표시할 강의 목록 가져오기
   */
  getCurrentPageLectures = () => {
    const { displayList, currentPage } = this.state;
    const startIndex = (currentPage - 1) * PAGE_COUNT;
    const endIndex = startIndex + PAGE_COUNT;
    
    return displayList.slice(startIndex, endIndex);
  };

  /**
   * 페이지네이션 컴포넌트 렌더링
   */
  renderPagination = () => {
    const { currentPage, totalPages } = this.state;
    
    if (totalPages <= 1) return null;

    const pages = [];
    const maxVisiblePages = 5;
    
    let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
    let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);
    
    // 페이지 범위 조정
    if (endPage - startPage + 1 < maxVisiblePages) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }

    // 이전 페이지 버튼
    if (currentPage > 1) {
      pages.push(
        <Button
          key="prev"
          onClick={() => this.handlePageChange(currentPage - 1)}
          style={{ margin: "0 4px" }}
        >
          이전
        </Button>
      );
    }

    // 페이지 번호 버튼들
    for (let i = startPage; i <= endPage; i++) {
      pages.push(
        <Button
          key={i}
          type={i === currentPage ? "primary" : "default"}
          onClick={() => this.handlePageChange(i)}
          style={{ margin: "0 4px" }}
        >
          {i}
        </Button>
      );
    }

    // 다음 페이지 버튼
    if (currentPage < totalPages) {
      pages.push(
        <Button
          key="next"
          onClick={() => this.handlePageChange(currentPage + 1)}
          style={{ margin: "0 4px" }}
        >
          다음
        </Button>
      );
    }

    return (
      <div style={{ textAlign: "center", margin: "40px 0" }}>
        {pages}
      </div>
    );
  };

  render() {
    const { pending } = this.props;
    const {
      solveQuiz,
      quizList,
      quizTitle,
      popupQuetureData,
      popupQuebonSongData,
      sortType,
      quizLectureId,
      quizQuetureId,
      lectureList,
      dateList,
      filterValue,
      courseTitle,
      searchTitle,
      onFilterTitle,
      lectureCountFilter,
    } = this.state;

    // 현재 페이지에 표시할 강의 목록
    const currentPageLectures = this.getCurrentPageLectures();

    return (
      <Skeleton loading={pending} active>
        {solveQuiz ? (
          <QuizList
            isSolveEndQuiz={this.state.isSolveEndQuiz}
            userId={this.props.user.userId}
            classroomId={this.props.user.classroom.classroomId}
            lectureId={quizLectureId}
            quetureId={quizQuetureId}
            quizList={quizList}
            title={quizTitle}
            onBack={() => {
              this.setState({
                solveQuiz: false,
              });
            }}
          />
        ) : (
          <>
            <HomeHeader lectures={this.props.lectures} />
            <div className="review-layout">
              {/* 강의가 없을 때 메시지 */}
              {!lectureList || lectureList.length === 0 ? (
                <p className="empty-content">
                  &lt;깨처 다시보기&gt;가 없습니다.
                </p>
              ) : (
                <>
                  {/* 필터 컴포넌트 */}
                  <Filter
                    filterCourse={courseTitle}
                    lectureCountFilter={lectureCountFilter}
                    sortType={sortType}
                    onChangeSortType={this.handleChangeSortType}
                    onFilter={this.handleFilter}
                    list={dateList}
                    filterValue={filterValue}
                    onFilterTitle={this.handleFilterCourseTitle}
                    filterValueTitle={onFilterTitle}
                    filterTitle={this.handleSearchTitle}
                  />
                  
                  {/* 강의 목록 */}
                  {currentPageLectures.map((lecture) => (
                    <div
                      key={lecture.lectureId}
                      className="review-layout-wrap"
                      style={{
                        backgroundColor: "white",
                        borderRadius: "16px",
                        marginBottom: "24px",
                      }}
                    >
                      {/* 강의 제목 */}
                      <div
                        className="ht-title"
                        style={{
                          marginBottom: "0px",
                          borderBottom: "2px solid #333332",
                          color: "#333333",
                          marginLeft: "40px",
                          width: "1120px",
                          paddingTop: "24px",
                          fontSize: "30px",
                          font: "HGSoftGGothicssi",
                          letterSpacing: "-1.5%",
                          lineHeight: "28.8px",
                        }}
                      >
                        {`${lecture.courseTitle[0]}코스 ${getSeqText(lecture)} 수업`}

                        <div
                          className="date-tag"
                          style={{
                            padding: "0px",
                            paddingTop: "24px",
                            fontSize: "20px",
                          }}
                        >
                          <span>{getKoreanDate(lecture.date)}</span>
                        </div>
                      </div>

                      {/* 깨처 목록 */}
                      <ReviewQuetureList
                        searchTitle={searchTitle}
                        onShowQueturePopup={(quetureData) => {
                          this.setState({
                            popupQuetureData: quetureData,
                          });
                        }}
                        handleFindSolveQuiz={this.handleFindSolveQuiz}
                        handleFindEndQuiz={this.handleFindEndQuiz}
                        onEnterSolveQuiz={this.handleEnterSolveQuiz}
                        onEnterEndQuiz={this.handleEnterEndQuiz}
                        quetureIds={values(
                          mapValues(
                            filter(lecture.sections, (section) => section.type === "QUETURE"),
                            (section) => section.quetureId
                          )
                        )}
                        lectureId={lecture.lectureId}
                      />

                      {/* 퀘봇송 컴포넌트 */}
                      {lecture?.sections &&
                        filter(lecture.sections, (section) => section.type === "QUETURE").length > 0 && (
                          <QuebonSongRow
                            lecture={lecture}
                            onShowQuebonSongPopup={(data) => {
                              this.setState({
                                popupQuebonSongData: data,
                              });
                            }}
                          />
                        )}
                    </div>
                  ))}

                  {/* 페이지네이션 */}
                  {this.renderPagination()}
                </>
              )}
            </div>
          </>
        )}

        {/* 깨처 팝업 */}
        {popupQuetureData && (
          <PopupQueture
            userId="tester"
            quetureData={popupQuetureData}
            isOpen={popupQuetureData !== null}
            onClose={() => {
              this.setState({
                popupQuetureData: null,
              });
            }}
            onCompleteQueture={() => {
              // 깨처 완료 처리
            }}
          />
        )}

        {/* 퀘봇송 팝업 */}
        {popupQuebonSongData && (
          <Popup
            type="quebot-videopopup"
            isOpen={popupQuebonSongData !== null}
            onClose={() => {
              this.setState({
                popupQuebonSongData: null,
              });
            }}
            className="ht-queture-popup"
          >
            <div className="popup-content-wrap">
              <div
                className="popup-closebtn"
                onClick={() => {
                  this.setState({
                    popupQuebonSongData: null,
                  });
                }}
              ></div>
              <div className="playerWrap" style={{ overflow: "hidden" }}>
                <QbPlayer
                  src={popupQuebonSongData?.content?.signedUrl}
                  viewType="preview"
                  controls={true}
                />
              </div>
            </div>
          </Popup>
        )}
      </Skeleton>
    );
  }
}

export default withRouter(
  connect(
    ({ auth, hometraining }) => ({
      pending: auth.pending || hometraining.pending,
      user: auth.user,
      logged: auth.logged,
      hometraining: hometraining,
      lectures: hometraining.lectures,
    }),
    (dispatch) => ({
      HometrainingActions: bindActionCreators(hometrainingActions, dispatch),
    })
  )(Review)
);
